/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Analytics = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 30 30">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4C5 3.44772 4.55228 3 4 3C3.44772 3 3 3.44772 3 4V29H28C28.5523 29 29 28.5523 29 28C29 27.4477 28.5523 27 28 27H5V4ZM8 8C7.44772 8 7 8.44772 7 9V24C7 24.5523 7.44772 25 8 25H12C12.5523 25 13 24.5523 13 24V9C13 8.44772 12.5523 8 12 8H8ZM9 23V10H11V23H9ZM15 15C15 14.4477 15.4477 14 16 14H20C20.5523 14 21 14.4477 21 15V24C21 24.5523 20.5523 25 20 25H16C15.4477 25 15 24.5523 15 24V15ZM17 16V23H19V16H17ZM24 5C23.4477 5 23 5.44772 23 6V24C23 24.5523 23.4477 25 24 25H28C28.5523 25 29 24.5523 29 24V6C29 5.44772 28.5523 5 28 5H24ZM27 23H25V7H27V23Z"
      />
    </BaseSvgIcon>
  )
}

export default Analytics
